// Where the app finds its API and Cognito, resolved at runtime by
// @jkast90/kast-common/config: each field from window.RUNTIME_CONFIG (the
// /config.js the deploy writes), the build's env, then a default. The
// Settings dialog's per-device API URL ("dashboard_api_url") is applied in
// settings.ts, which also drops one left over from local development; this
// stays the auto-detected value the dialog shows next to it.

import { createDeploymentConfig } from "@jkast90/kast-common/config";

export const deploymentConfig = createDeploymentConfig({
  env: import.meta.env,
  fields: {
    apiUrl: {
      key: "VITE_WORKSPACE_API_BASE_URL",
      // Locally the API is the dev proxy on 8443, always HTTPS.
      default: (c) =>
        c.isLocalhost
          ? `https://${c.hostname}:8443`
          : `${c.protocol}//${c.hostname}`,
    },
    cognitoDomain: "VITE_COGNITO_DOMAIN",
    cognitoUiUrl: "VITE_COGNITO_UI_URL",
    clientId: "VITE_COGNITO_CLIENT_ID",
  },
});

export const getDeploymentConfig = deploymentConfig.get;
